import React, { useState, useContext, useEffect, useCallback } from 'react';
import LoginModule from '../modules/LoginModule';
import RegisterModule from '../modules/RegisterModule';
import ForgotPasswordModule from '../modules/ForgotPasswordModule';
import { withRouter } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { notificationTypeEnum } from '../enums/NotificactionTypeEnum';
import Notification from '../components/Notification';
import ScrollToTop from '../components/ScrollToTop';
import { withCookies } from 'react-cookie';
import Globals from '../Globals';

import UserService from 'services/UserService';

import '../components/css/Login.css';

const logo = require('../images/Logo.png');

function LoginPage({ cookies, history }) {
    const [renderModuleType, setRenderModuleType] = useState(
        history?.location?.pathname === Globals.APPLICATION_PATH.REGISTER
            ? 2
            : 1 //2 for register, 1 for default login, checks for register hash params
    );
    const [notificationData, setNotificationData] = useState({
        notificationType: '',
        message: '',
    });
    const {
        setLogged,
        setUser,
        setBuyerType,
        sethasTransportAvailable,
        user,
    } = useContext(UserContext);

    // useEffect(() => {
    //     if (history?.location?.state?.pendingRefresh) {
    //         const refreshPageListener = async () => {
    //             if (window.caches) {
    //                 const names = await window.caches.keys();
    //                 await Promise.all(
    //                     names.map(name => window.caches.delete(name))
    //                 );
    //             }
    //             window.removeEventListener('mousemove', refreshPageListener);
    //             window.location.reload();
    //         };
    //         window.addEventListener('mousemove', refreshPageListener);
    //     }
    // }, [history?.location?.state?.pendingRefresh]);

    useEffect(() => {
        if (user.logged) {
            history.push(Globals.APPLICATION_PATH.HOME);
        } else {
            cookies.remove(Globals.COOKIES.JWT, {
                path: process.env.PUBLIC_URL,
            });
            cookies.remove(Globals.COOKIES.USER, {
                path: process.env.PUBLIC_URL,
            });
        }
    }, [cookies, history, user.logged]);

    const handleLoginUser = useCallback(
        async (userData, cookie) => {
            setUser(userData);
            setLogged(true);
            try {
                const response = await new UserService().getBuyerType(
                    cookie?.AccessToken
                );
                const buyerType = JSON.parse(response?.Result);
                setBuyerType(buyerType);
                if (buyerType != null) {
                    sethasTransportAvailable(buyerType === 2);
                }
                let tomorrow = new Date();
                tomorrow.setDate(
                    tomorrow.getDate() +
                        parseInt(process.env.REACT_APP_JWT_EXPIRES)
                );
                const cookieOptions = {
                    path: process.env.PUBLIC_URL,
                    expires: tomorrow,
                    //maxAge: parseInt(process.env.REACT_APP_JWT_MAXAGE), //in milliseconds
                    // secure: true,
                    // httpOnly: true
                };
                const userId = userData?.UserId?.toString().replace(' ', '');
                cookies.set(Globals.COOKIES.JWT, cookie, cookieOptions);
                cookies.set(Globals.COOKIES.USER, userId, cookieOptions);
                history.push(Globals.APPLICATION_PATH.HOME);
            } catch (error) {
                console.log(error);
            }
        },
        [
            cookies,
            history,
            setBuyerType,
            setLogged,
            setUser,
            sethasTransportAvailable,
        ]
    );

    const renderLoginModuleType = () => {
        if (renderModuleType === 1) {
            return (
                <LoginModule
                    setRenderModuleType={setRenderModuleType}
                    handleLoginUser={handleLoginUser}
                />
            );
        } else if (renderModuleType === 2) {
            return (
                <RegisterModule
                    history={history}
                    setNotification={setNotification}
                    setRenderModuleType={setRenderModuleType}
                    cookies={cookies}
                    handleLoginUser={handleLoginUser}
                />
            );
        } else {
            return (
                <ForgotPasswordModule
                    setRenderModuleType={setRenderModuleType}
                />
            );
        }
    };

    const setNotification = useCallback((typeNotification, message) => {
        setNotificationData({
            notificationType: typeNotification,
            message: message,
        });
        document.querySelector('body').scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, []);

    const showNotification = () => {
        return notificationData.notificationType !==
            notificationTypeEnum.NOSHOW ? (
            <Notification
                notificationData={notificationData}
                setNotification={setNotification}
            />
        ) : null;
    };

    return (
        <div
            className="c-hero-teaser c-hero-teaser--auto c-hero-teaser--login"
            data-testid="loginPageTestId"
        >
            <ScrollToTop></ScrollToTop>
            <img
                className="c-hero-teaser__image"
                src={
                    process.env.PUBLIC_URL +
                    '/Bronson/img/rema_mobile_background.jpg'
                }
                sizes="100vw"
                alt="Rema Mobile Home"
            />
            {showNotification()}
            <div id="js-hero-teaser-content" className="c-hero-teaser__content">
                <div className="c-hero-teaser__content-inner">
                    <div className="c-hero-teaser__box u-mt-small boxLogin">
                        <form action="#">
                            <fieldset className="o-fieldset">
                                <legend className="c-form-heading">
                                    <strong className="c-form-heading__title">
                                        <img
                                            src={String(logo)}
                                            alt="Rema Mobile"
                                            height="40"
                                        ></img>
                                    </strong>
                                </legend>
                                {renderLoginModuleType(renderModuleType)}
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withCookies(withRouter(LoginPage));
